import React from "react";
import {
  GroupingAttributes,
  VariationMembership,
} from "~/common/Store/models/ProductListing";
import combineVariationsAndVirtualGroupingOptions from "./useVariationsAndVirtualGroupingOptionsForOptionLabel";
import Badge from "./Badge";
import VariationOptionLabel from "./VariationOptionLabel";

interface BadgeAndOptionTextProps {
  showBadge: boolean;
  hasVariations: boolean;
  badgeDisplayText: string;
  badgeImagePath: string;
  groupingAttributes: GroupingAttributes;
  variations?: VariationMembership;
  isListView?: boolean;
}

const BadgeAndOptionText = ({
  showBadge,
  hasVariations,
  badgeDisplayText,
  badgeImagePath,
  groupingAttributes,
  variations,
  isListView = false,
}: BadgeAndOptionTextProps) => {
  const hasColorVariation =
    variations?.variationGroups.some((group) => group.optionName === "Color") ||
    false;
  const hasColorBadge = badgeDisplayText === "Colors";
  const itemDisplaysBadge =
    showBadge &&
    ((hasVariations && !(hasColorVariation && hasColorBadge)) ||
      !hasVariations);

  const optionsData = combineVariationsAndVirtualGroupingOptions({
    groupingAttributes,
    variationMembership: variations,
    itemDisplaysBadge,
    isListView,
  });

  if (!optionsData) {
    return (
      <span className="inline-flex items-center justify-center">
        {showBadge && (
          <Badge text={badgeDisplayText} badgeImage={badgeImagePath} />
        )}
      </span>
    );
  }

  const {
    uniqueCounts,
    numberOfUniqueOptions,
    wrapperClass,
    overrideMap,
    shouldDisplayOptionText,
    optionTextWrapperClass,
  } = optionsData;

  return (
    <span className="inline-flex items-center justify-center">
      {itemDisplaysBadge && (
        <Badge text={badgeDisplayText} badgeImage={badgeImagePath} />
      )}
      {(groupingAttributes.isVirtual || hasVariations) && (
        <VariationOptionLabel
          uniqueCounts={uniqueCounts}
          numberOfUniqueOptions={numberOfUniqueOptions}
          wrapperClass={wrapperClass}
          overrideMap={overrideMap}
          shouldDisplayOptionText={shouldDisplayOptionText}
          optionTextWrapperClass={optionTextWrapperClass}
        />
      )}
    </span>
  );
};

export default React.memo(BadgeAndOptionText);
